export default __webpack_public_path__ + "static/media/spawn.dcb5ecc2.mp3";